module.exports = "/images/magnet-1923.jpg?8001daedc888096140b4326de3600a95";